import { useAppDispatch } from '@verantos-dev/core-annotation-tool';

import { AddedConcept, setConceptInEditMode, removeConcept } from '../../state/createProjectSlice';

interface UseSavedConceptGroupAndAttributeCardProps {
  concept: AddedConcept;
}

interface UseSavedConceptGroupAndAttributeCardResults {
  handleEditConcept: () => void;
  removeAddedConcept: () => void;
}
export const useSavedConceptGroupAndAttributeCard = ({
  concept,
}: UseSavedConceptGroupAndAttributeCardProps): UseSavedConceptGroupAndAttributeCardResults => {
  const dispatch = useAppDispatch();

  const handleEditConcept = () => {
    dispatch(setConceptInEditMode(concept.conceptCardId));
  };

  const removeAddedConcept = () => {
    dispatch(removeConcept(concept.conceptCardId));
  };

  return {
    handleEditConcept,
    removeAddedConcept,
  };
};
